var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box"},[_c('div',{staticClass:"warp",on:{"click":_vm.handleonOff}},[_c('span',{class:['text', {texts:_vm.flage}]},[_vm._v(_vm._s(_vm.type))]),_vm._v(" "),_c('span',{class:['circle', {circles:_vm.flage}]})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f170861","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Condition/components/OnOff/OnOff.vue
// module id = xJkX
// module chunks = 2